import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';
import { AngularFirestoreModule, SETTINGS } from '@angular/fire/firestore';
import { AngularFireFunctionsModule, AngularFireFunctions, ORIGIN, REGION } from '@angular/fire/functions';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';

import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSliderModule } from '@angular/material/slider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatBottomSheetModule, MAT_BOTTOM_SHEET_DEFAULT_OPTIONS } from '@angular/material/bottom-sheet';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioModule } from '@angular/material/radio'
import { MatDatepickerModule, MatDatepicker } from '@angular/material/datepicker';
import { MatTabsModule } from '@angular/material/tabs';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MatMomentDateModule, MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from "@angular/material-moment-adapter";

import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule } from '@angular/fire/storage';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxFileDropModule } from 'ngx-file-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import 'firebase/storage';
import { LoginDialogComponent } from './login-dialog/login-dialog.component';
import { LoadingDialogComponent } from './loading-dialog/loading-dialog.component';
import { PasswordResetDialogComponent } from './password-reset-dialog/password-reset-dialog.component';
import { OrderDialogComponent } from './order-dialog/order-dialog.component';
import { UserPanelComponent, UserPanelOrderUpgradeComponent } from './user-panel/user-panel.component';
import { CalculatorComponent } from './calculator/calculator.component';
import { UserjumbotronComponent } from './user-jumbotron/userjumbotron.component';
import { HeaderComponent } from './header/header.component';
import { ClipsDialogComponent } from './clips-dialog/clips-dialog.component';
import { ClipComponent } from './clip/clip.component';
import { FooterComponent } from './footer/footer.component';
import { ReservationPopupComponent } from './reservation-popup/reservation-popup.component'
import { UplatnicaDialogComponent } from './uplatnica-dialog/uplatnica-dialog.component';
import { RegisterDialogComponent } from './register-dialog/register-dialog.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { TosDialogComponent } from './tos-dialog/tos-dialog.component';
import { NewPasswordDialogComponent } from './new-password-dialog/new-password-dialog.component';
import { OnlyChromeComponent } from './only-chrome/only-chrome.component';
import { SubjectUpgradeDialogComponent } from './subject-upgrade-dialog/subject-upgrade-dialog.component';
import { MatNativeDateModule, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { YouThereDialogComponent } from './user-panel/you-there-dialog/you-there-dialog.component';
import { ExtensionAlertComponent } from './clip/extension-alert/extension-alert.component';
import { ExtensionAlertDialogComponent } from './clips-dialog/extension-alert-dialog/extension-alert-dialog.component';
import { QuizComponent } from './quiz/quiz.component';
import { YtVideosComponent } from './yt-videos/yt-videos.component';
import { TestsComponent } from './user-panel/tests/tests.component';
import { ReservationsComponent } from './user-panel/reservations/reservations.component';
import { OrdersComponent } from './user-panel/orders/orders.component';
import { SubjectsComponent } from './user-panel/subjects/subjects.component';
import { RegularOrderComponent } from './user-panel/orders/regular-order/regular-order.component';
import { DeletedOrderComponent } from './user-panel/orders/deleted-order/deleted-order.component';
import { PaidOrderComponent } from './user-panel/orders/paid-order/paid-order.component';
import { UpgradeOrderComponent } from './user-panel/orders/upgrade-order/upgrade-order.component';
import { UpgradePaidOrderComponent } from './user-panel/orders/upgrade-paid-order/upgrade-paid-order.component';
import { ListSubjectsComponent } from './user-panel/orders/list-subjects/list-subjects.component';
import { FacultyComponent } from './user-panel/subjects/faculty/faculty.component';
import { AdmitanceComponent } from './user-panel/subjects/admitance/admitance.component';
import { StudyboxClipsDialogComponent } from './user-panel/subjects/studybox-clips-dialog/studybox-clips-dialog.component';
import { UplatnicaComponent } from './uplatnica-dialog/uplatnica/uplatnica.component';
import { SubjectsChooserDialogComponent } from './subjects-chooser-dialog/subjects-chooser-dialog.component';
import { InfoComponent } from './subjects-chooser-dialog/info/info.component';
import { SubjectsTableComponent } from './subjects-chooser-dialog/subjects-table/subjects-table.component';
import { ThankYouComponent } from './subjects-chooser-dialog/thank-you/thank-you.component';
import { OfferComponent } from './subjects-chooser-dialog/offer/offer.component';
import {MatSelectModule} from '@angular/material/select';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'DD. MMM, YYYY',
    monthYearLabel: 'MMM',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@NgModule({
  declarations: [
    AppComponent,
    OrderDialogComponent,
    LoadingDialogComponent,
    LoginDialogComponent,
    LoadingDialogComponent,
    PasswordResetDialogComponent,
    OrderDialogComponent,
    UserPanelComponent,
    CalculatorComponent,
    UserjumbotronComponent,
    HeaderComponent,
    ClipsDialogComponent,
    ClipComponent,
    FooterComponent,
    UplatnicaDialogComponent,
    RegisterDialogComponent,
    TermsOfServiceComponent,
    TosDialogComponent,
    NewPasswordDialogComponent,
    OnlyChromeComponent,
    SubjectUpgradeDialogComponent,
    UserPanelOrderUpgradeComponent,
    YouThereDialogComponent,
    ExtensionAlertComponent,
    ExtensionAlertDialogComponent,
    ReservationPopupComponent,
    QuizComponent,
    YtVideosComponent,
    TestsComponent,
    ReservationsComponent,
    OrdersComponent,
    SubjectsComponent,
    RegularOrderComponent,
    DeletedOrderComponent,
    PaidOrderComponent,
    UpgradeOrderComponent,
    UpgradePaidOrderComponent,
    ListSubjectsComponent,
    FacultyComponent,
    AdmitanceComponent,
    StudyboxClipsDialogComponent,
    UplatnicaComponent,
    SubjectsChooserDialogComponent,
    InfoComponent,
    SubjectsTableComponent,
    ThankYouComponent,
    OfferComponent
  ],
  entryComponents: [
    OrderDialogComponent,
    LoginDialogComponent,
    TosDialogComponent,
    PasswordResetDialogComponent,
    RegisterDialogComponent,
    NewPasswordDialogComponent,
    SubjectUpgradeDialogComponent,
    MatDatepicker,
    YouThereDialogComponent,
    ExtensionAlertDialogComponent,
    ReservationPopupComponent
  ],
  imports: [
    NgIdleKeepaliveModule.forRoot(),
    HttpClientModule,
    NgxFileDropModule,

    BrowserModule,
    AppRoutingModule,

    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireAnalyticsModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,

    MatSliderModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatCheckboxModule,
    MatListModule,
    MatDividerModule,
    MatBottomSheetModule,
    MatChipsModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatDialogModule,
    MatSnackBarModule,
    MatStepperModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatSelectModule,
    FormsModule, ReactiveFormsModule,

    BrowserAnimationsModule
  ],
  providers: [
    // { provide: ORIGIN, useValue: 'http://localhost:5000' },
    // { provide: REGION, useValue: 'us-central1' }
    { provide: MAT_DIALOG_DATA, useValue: {} }, {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    }, { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    // {
    //   provide: SETTINGS,
    //   useValue: environment.production ? undefined : {
    //     host: 'localhost:8080',
    //     ssl:false,
    //     experimentalForceLongPolling:true
    //   }
    // }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
